/**
 * <StudentModalHeader />
 *
 * this is a custom modal header
 *
 * @parent mostly Modal
 * @stateless
 */
import React, { Component } from 'react';
import classnames from 'classnames';
import './StudentModalHeader.scss';
import MALE_IMG from 'data/images/Male_student.png';
import FEMALE_IMG from 'data/images/Female_student.png';
import NEUTRAL_IMG from 'data/images/default-logo.png';
import MALE_USER_PORTRAIT from 'data/images/male-user-icon.png';
import FEMALE_USER_PORTRAIT from 'data/images/female-user-icon.png';
import PhotoViewer from 'template/Modals/Photo';

class StudentModalHeader extends Component {

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const {
      profilePhoto,
    } = this.props;

    PhotoViewer({ photo: profilePhoto });
  }

  render() {
    const { name, gender, profilePhoto, profileThumbnail, type } = this.props;
    let portrait;
    let hasProfilePhoto = false;
    
    if(profileThumbnail) {
      portrait = profileThumbnail;
      hasProfilePhoto = true;
    } else if (type == 'teacher'){
      switch (gender) {
        case 0:
        case 'male':
          portrait = MALE_USER_PORTRAIT;
          break;
        case 1:
        case 'female':
          portrait = FEMALE_USER_PORTRAIT;
          break;
        case 2:
          portrait = NEUTRAL_IMG;
          break;
        case 3:
          portrait = NEUTRAL_IMG;
          break;
      }
    } else {
      switch (gender) {
        case 0:
        case 'male':
          portrait = MALE_IMG;
          break;
        case 1:
        case 'female':
          portrait = FEMALE_IMG;
          break;
        case 2:
          portrait = NEUTRAL_IMG;
          break;
        case 3:
          portrait = NEUTRAL_IMG;
          break;
      }
    }

    return (
      <div className='student-modal-header'>
        <div className={classnames('portrait', { hasProfilePhoto })}
          onClick={this.onClick}
          style={{
            backgroundImage: `url(${portrait})`
          }}>
        </div>
        <div className='student-name'>{name}</div>
      </div>
    )
  }
}

export default StudentModalHeader;



// WEBPACK FOOTER //
// ./src/components/UI/StudentModalHeader/index.js